import styled from 'styled-components';

export const FormField = styled.div.attrs(props => ({
    className: `form-field ffn-${props.name} fft-${props.type} ffs-${props.size}`,
}))`
    flex: 0 0 ${props => (props.size ? `calc(100%/12 * ${props.size})` : 'auto')};
`;
